import * as types from './constants';

// Get Unmasking Connection
export const getUnmaskingConnectionRequest = data => (
  { type: types.GET_UNMASKING_CONNECTION_REQUEST, payload: data }
);

export const getUnmaskingConnectionDone = data => (
  { type: types.GET_UNMASKING_CONNECTION_DONE, payload: data }
);

export const getUnmaskingConnectionFailed = errors => (
  { type: types.GET_UNMASKING_CONNECTION_FAILED, payload: errors }
);